// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__29dp2","head":"ProcedureTableInfo_head__3lR7a"};